import * as api from 'src/api/recistScoring';

import { getUrlParams } from '../helpers';
import { runToast } from '../tools';

export const calculateRecistForCurrentReading = async () => {
  const {
    id: clinicalTrialId,
    taskId: parentTaskId,
    subTaskId: taskId,
  } = getUrlParams() ?? {};

  if (!clinicalTrialId || !parentTaskId || !taskId) {
    throw new Error(
      'Cannot calculate RECIST: the reading route is not resolved'
    );
  }

  try {
    const { data } = await api.calculateRecistScoring({
      clinicalTrialId,
      parentTaskId,
      taskId,
    });

    return data;
  } catch (error) {
    runToast('error', 'Failed to calculate RECIST 1.1 response');
    console.error('Calculate RECIST 1.1 error', error);

    throw error;
  }
};
